export default __webpack_public_path__ + "static/media/undraw_shopping_app.aa21511f.svg";